// @ts-nocheck
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { css } from "styled-components";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import useExpandProps from "@toolkit/Framework/Common/Hooks/useExpandProps";
import React, { HTMLAttributes } from "react";

interface ProductNumberProps {
    product: ProductContextModel | ProductModel;
    extendedStyles?: ProductModelNumberStyles;
    overridedStyles?: ProductModelNumberStyles;
}

type Props = ProductNumberProps & HTMLAttributes<HTMLElement>;

export interface ProductModelNumberStyles {
    productModelNumber?: TypographyProps;
}

export const productModelNumberStyles: ProductModelNumberStyles = {
    productModelNumber: {
        css: css`
            font-size: ${x => x.theme.design.typography.size.smaller};
            font-weight: ${x => x.theme.design.typography.weight.medium};
            text-transform: uppercase;
        `,
    },
};

const ProductModelNumber = ({ product: baseProduct, extendedStyles, overridedStyles }: Props) => {
    const styles = useExpandProps(productModelNumberStyles, extendedStyles, overridedStyles);
    const product = "product" in baseProduct ? baseProduct.product : baseProduct;

    const modelNumber = product.detail?.modelNumber;

    if (!modelNumber) {
        return null;
    }

    return <Typography {...styles.productModelNumber}>{modelNumber}</Typography>;
};

export default ProductModelNumber;
